module.exports = require('./helpers/bundle-url').getBundleURL('9nzY3') + "logo-dark.eefe0b7f.svg";